import { SectionHeader } from "../shared/SectionHeader";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const THIRD_PARTY = [
  { name: "Lenco", license: "Payment processor", url: "https://lenco.co/zm" },
  { name: "React", license: "MIT", url: "https://react.dev" },
  { name: "Vite", license: "MIT", url: "https://vitejs.dev" },
  { name: "TypeScript", license: "Apache 2.0", url: "https://typescriptlang.org" },
  { name: "Tailwind CSS", license: "MIT", url: "https://tailwindcss.com" },
  { name: "Supabase", license: "Apache 2.0", url: "https://supabase.com" },
  { name: "Recharts", license: "MIT", url: "https://recharts.org" },
  { name: "react-hook-form", license: "MIT", url: "https://react-hook-form.com" },
  { name: "Zod", license: "MIT", url: "https://zod.dev" },
  { name: "date-fns", license: "MIT", url: "https://date-fns.io" },
  { name: "Lucide React", license: "ISC", url: "https://lucide.dev" },
];

export function Legal() {
  return (
    <>
      <SectionHeader
        title="Legal"
        description="Privacy, terms, and third-party notices."
      />
      <Card className="bg-card border-border mb-4">
        <CardHeader>
          <p className="text-[11px] font-mono text-muted-foreground">Last updated: March 2026</p>
          <p className="text-[12px] text-muted-foreground mt-1">
            ReviewBoost Pro Manager collects and processes your business data solely to provide the service. We do not sell your data.
          </p>
        </CardHeader>
        <CardContent>
          <Button variant="outline" size="sm" asChild>
            <a href="/privacy" target="_blank" rel="noopener noreferrer">Read Full Privacy Policy →</a>
          </Button>
        </CardContent>
      </Card>
      <Card className="bg-card border-border mb-4">
        <CardHeader>
          <p className="text-[11px] font-mono text-muted-foreground">Last updated: March 2026</p>
          <p className="text-[12px] text-muted-foreground mt-1">
            By using ReviewBoost Pro Manager you agree to our terms of service.
          </p>
        </CardHeader>
        <CardContent>
          <Button variant="outline" size="sm" asChild>
            <a href="/terms" target="_blank" rel="noopener noreferrer">Read Full Terms of Service →</a>
          </Button>
        </CardContent>
      </Card>
      <Card className="bg-card border-border">
        <CardHeader>
          <h3 className="text-[14px] font-semibold text-foreground">Third-Party Software &amp; Services Notices</h3>
          <p className="text-[12px] text-muted-foreground">ReviewBoost is built on open-source software and uses Lenco for payment processing.</p>
        </CardHeader>
        <CardContent>
          <div className="max-h-64 overflow-y-auto space-y-2">
            {THIRD_PARTY.map(({ name, license, url }) => (
              <div key={name} className="flex items-center justify-between gap-2 text-[12px]">
                <span className="font-mono text-foreground">{name}</span>
                <span className="text-muted-foreground">{license}</span>
                <a href={url} target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">↗</a>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </>
  );
}
